import Api from '@/services/Api'

export default {
  /**
   * Meldet eine Bestellung als problematisch
   * @param {string|number} orderId - Die ID der zu meldenden Bestellung
   * @param {Object} reportData - Die Daten für die Meldung (sollte customerId, appId, reason, plentyId enthalten)
   * @returns {Promise} - Promise mit der Antwort vom Server
   */
  reportOrder(orderId, reportData) {
    return Api().post(`/orders/${orderId}/report`, reportData)
  },

  /**
   * Storniert eine Bestellung
   * @param {string|number} orderId - Die ID der zu stornierenden Bestellung
   * @param {Object} cancelData - Daten für die Stornierung (z.B. reason, plentyId)
   * @returns {Promise} - Promise mit der Antwort vom Server
   */
  cancelOrder(orderId, cancelData) {
    return Api().post(`/orders/${orderId}/cancel`, cancelData)
  }
} 